import { HexagramOutlineIcon } from './HexagramOutlineIcon';

/**
 * author: Michael Irigoyen
 * id C1F53791-B46C-4327-B355-AF3175766CB8
 * name hexagram-outline
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hexagram-outline.svg
 * tags
 * - Shape 
 * - Holiday 
 */
export const ChristmasStarOutlineIcon = HexagramOutlineIcon;
export default ChristmasStarOutlineIcon